import {
   Stack,
   ContentCard,
   Grid,
   Button,
   WeeklyAvailability,
   Select,
} from '@forwardflow/ui-v2'
import { ArrowLeftMdIcon, ChevronRightIcon } from '@forwardflow/icons'
import { motion } from 'framer-motion'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { timeZones } from '@forwardflow/helpers/utils'
import { useState } from 'react'
import { IAvailabilityDay } from '@forwardflow/types/onboarding'

export const UserAvailability = () => {
   const {
      getNextStep,
      getPreviousStep,
      setAppointmentTimeframe,
      onboardingData,
   } = useOnboardingStoreV2()
   const { appointmentTimeframe } = onboardingData
   const [selectedDays, setSelectedDays] = useState<IAvailabilityDay[]>(appointmentTimeframe?.days ?? [])
   const [isSameForAllDays, setIsSameForAllDays] = useState(appointmentTimeframe?.isSameForAllDays ?? false)
   const handleTimeZoneChange = (value: string) => {
      setAppointmentTimeframe({
         ...appointmentTimeframe,
         timezone: value,
      })
   }

   const handleWeeklyAvailabilityChange = () => {
      setAppointmentTimeframe({
         ...appointmentTimeframe,
         days: selectedDays,
         isSameForAllDays: isSameForAllDays,
      })
   }

   return (
      <Stack gap={32}>
         <ContentCard
            className="space-y-2"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
         >
            <p className="text-white font-medium">Set your availability</p>
            <p className="text-[#99A1AF] text-sm font-medium max-w-[600px]">
               Tell us when Forward Flow can book calls, meetings, or property
               viewings. You can change this anytime.
            </p>
         </ContentCard>

         <ContentCard
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.6 }}
         >
            <Select
               value={appointmentTimeframe?.timezone}
               data={timeZones}
               placeholder="Select Timezone"
               label="Select Timezone"
               onChange={(value) => handleTimeZoneChange(value as string)}
            />
         </ContentCard>

         <ContentCard
            className="!p-0"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.6 }}
         >
            <Stack gap={4} className="p-8 pb-0">
               <p className="text-white font-medium">Weekly Availability</p>
               <p className="text-[#99A1AF] text-sm font-medium">
                  Pick days and time windows when you're available
               </p>
            </Stack>
            <WeeklyAvailability
               isSameForAllDays={isSameForAllDays}
               setIsSameForAllDays={setIsSameForAllDays}
               selectedDays={selectedDays}
               setSelectedDays={setSelectedDays}
            />
         </ContentCard>
         <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.9 }}
         >
            <Grid>
               <Grid.Col span={3}>
                  <Button
                     variant="secondary"
                     className="w-full"
                     onClick={() => getPreviousStep()}
                  >
                     <ArrowLeftMdIcon width={12} /> Back
                  </Button>
               </Grid.Col>
               <Grid.Col span={9}>
                  <Button className="w-full" onClick={() => {
                     handleWeeklyAvailabilityChange()
                     getNextStep()
                  }} disabled={!appointmentTimeframe?.timezone || !selectedDays?.some((d) => d.enabled)}>
                     Confirm and Continue <ChevronRightIcon width={18} />
                  </Button>
               </Grid.Col>
            </Grid>
         </motion.div>
      </Stack>
   )
}
